const userProfileQuery = `
        query getUserProfile($userEmail: String) {
            chimera {
                userProfile(email: $userEmail) {
                  id
                  firstName
                  lastName
                  email
                  picture
                  pictureSHA
                  isUnfitPhoto
                }
            }
        }
        `;

const meUserQuery = `
query getMeUser {
    chimera {
        me {
            id
            name
            email
            picture
            roles {
            id
            name
            }
            featureFlags(names: [
                "undergrad-alpha-testing",
            ])
        }
    }
}
    `;

export { userProfileQuery, meUserQuery };
